import _ from 'lodash';
import { t } from '@lingui/macro';
import { agentFilterId, businessServiceFilterId, siteFilterId, testFilterId } from '../filters';
import { ENTITY_TYPES } from '../../services/EntityService';

export const BUSINESS_SERVICE_TYPE = ENTITY_TYPES.BUSINESS_SERVICE;
export const SITE_TYPE = ENTITY_TYPES.SITE;
export const SERVICE_TEST_TYPE = ENTITY_TYPES.TEST;
export const AGENT_TYPE = ENTITY_TYPES.AGENT;
export const HYPERVISOR_TYPE = ENTITY_TYPES.HYPERVISOR;
export const VIRTUAL_MACHINE_TYPE = ENTITY_TYPES.VIRTUAL_MACHINE;

const pageStateParams = ['SelectedTime'];

export default function getMatrixTypeConfig() {
    const columnConfig = {};
    _.set(columnConfig, `${SITE_TYPE}.nameSortField`, 'agent.name');
    _.set(columnConfig, `${SITE_TYPE}.title`, t`Sites`);
    _.set(columnConfig, `${SITE_TYPE}.titleSingular`, t`Site`);
    _.set(columnConfig, `${SITE_TYPE}.link`, {
        target: 'site-detail',
        mappedFilterParams: {
            [siteFilterId]: SITE_TYPE,
        },
        pageStateParams,
    });

    _.set(columnConfig, `${AGENT_TYPE}.nameSortField`, 'agent.name');
    _.set(columnConfig, `${AGENT_TYPE}.title`, t`nPoints`);
    _.set(columnConfig, `${AGENT_TYPE}.titleSingular`, t`nPoint`);
    _.set(columnConfig, `${AGENT_TYPE}.link`, {
        target: 'agent-detail',
        mappedFilterParams: {
            [agentFilterId]: AGENT_TYPE,
        },
    });

    const rowConfig = {};
    _.set(rowConfig, `${BUSINESS_SERVICE_TYPE}.nameSortField`, 'businessservice.name');
    _.set(rowConfig, `${BUSINESS_SERVICE_TYPE}.title`, t`Business Services`);
    _.set(rowConfig, `${BUSINESS_SERVICE_TYPE}.titleSingular`, t`Business Service`);
    _.set(rowConfig, `${BUSINESS_SERVICE_TYPE}.link`, {
        target: 'business-service-detail',
        mappedFilterParams: {
            [businessServiceFilterId]: BUSINESS_SERVICE_TYPE,
        },
        pageStateParams,
    });

    _.set(rowConfig, `${SERVICE_TEST_TYPE}.nameSortField`, 'test.name');
    _.set(rowConfig, `${SERVICE_TEST_TYPE}.title`, t`Service Tests`);
    _.set(rowConfig, `${SERVICE_TEST_TYPE}.titleSingular`, t`Service Test`);
    _.set(rowConfig, `${SERVICE_TEST_TYPE}.link`, {
        target: 'test-detail',
        mappedFilterParams: {
            [testFilterId]: SERVICE_TEST_TYPE,
        },
    });

    _.set(rowConfig, `${SERVICE_TEST_TYPE}-drill.nameSortField`, 'businessservice.name');
    _.set(rowConfig, `${SERVICE_TEST_TYPE}-drill.title`, t`Service Tests`);
    _.set(rowConfig, `${SERVICE_TEST_TYPE}-drill.titleSingular`, t`Service Test`);
    _.set(rowConfig, `${SERVICE_TEST_TYPE}-drill.link`, {
        target: 'tests',
        mappedFilterParams: {
            [businessServiceFilterId]: BUSINESS_SERVICE_TYPE,
        },
    });

    _.set(rowConfig, `${ENTITY_TYPES.SERVER}-drill.nameSortField`, 'businessservice.name');
    _.set(rowConfig, `${ENTITY_TYPES.SERVER}-drill.title`, t`Servers`);
    _.set(rowConfig, `${ENTITY_TYPES.SERVER}-drill.titleSingular`, t`Server`);
    _.set(rowConfig, `${ENTITY_TYPES.SERVER}-drill.link`, {
        target: 'servers',
        mappedFilterParams: {
            [businessServiceFilterId]: BUSINESS_SERVICE_TYPE,
        },
    });

    _.set(rowConfig, `${ENTITY_TYPES.DEVICE}-drill.nameSortField`, 'businessservice.name');
    _.set(rowConfig, `${ENTITY_TYPES.DEVICE}-drill.title`, t`Network Devices`);
    _.set(rowConfig, `${ENTITY_TYPES.DEVICE}-drill.titleSingular`, t`Network Device`);
    _.set(rowConfig, `${ENTITY_TYPES.DEVICE}-drill.link`, {
        target: 'network-devices',
        mappedFilterParams: {
            [businessServiceFilterId]: BUSINESS_SERVICE_TYPE,
        },
    });

    const cellConfig = {};
    _.set(cellConfig, `${BUSINESS_SERVICE_TYPE}.matrixCellLink`, {
        target: 'tests',
        mappedFilterParams: {
            [businessServiceFilterId]: BUSINESS_SERVICE_TYPE,
        },
    });
    _.set(cellConfig, `${BUSINESS_SERVICE_TYPE}.matrixCellSecondaryFilterId`, siteFilterId);

    _.set(cellConfig, `${SERVICE_TEST_TYPE}.matrixCellLink`, {
        target: 'test-log',
        mappedFilterParams: {
            [testFilterId]: SERVICE_TEST_TYPE,
        },
    });
    _.set(cellConfig, `${SERVICE_TEST_TYPE}.matrixCellSecondaryFilterId`, agentFilterId);

    return { rowConfig, columnConfig, cellConfig };
}
